import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserCurrent} from '@core/modules/authentication/interfaces/user-current.interface';
import {ComponentHelper} from '@shared/helpers/component.helper';
import {Roles} from '@core/modules/role/enums/roles.enum';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent extends ComponentHelper implements OnInit, OnDestroy {
  public readonly Roles = Roles;

  public username: string;
  public role: string;
  public companyName: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.username = this.service.userInfo.getFullUsernameFromToken();
    this.role = this.service.userInfo.getRoleName();
    this.companyName = this.service.userInfo.getCompanyName();

    this.subscriptions.add(
      this.service.userInfo.getUser$.subscribe((user: UserCurrent) => {
        if (user) {
          this.username = `${user.name} ${user.surname}`;
        }
      }));
  }

  ngOnDestroy(): void {
    this.service.userInfo.userSubjectReset();
    super.ngOnDestroy();
  }
}
